declare var cordova: any;
export class CordovaPlugin {
  constructor(private serviceName: string) {
  }
  exec<T = any>(methodName: string, ...args) {
    return new Promise<T>((resolve, reject) => cordova.exec(resolve, reject, this.serviceName, methodName, args));
  }
}
